import * as actions from "./actions";
import * as types from "./types";
import { Platform } from "react-native";
import {
  getBuildNumber,
  getManufacturer,
  getDeviceName as _getDeviceName,
} from "react-native-device-info";

import { getFingerprint } from "utils";
import { apiCall, VERSION_CHECK_URL } from "apis";

export const checkVersion = () => dispatch => {
  if (Platform.OS === "web") {
    return;
  }

  dispatch(
    apiCall({
      type: types.GET_APP_VERSION,
      payload: {
        url: VERSION_CHECK_URL(Platform.OS),
        onSuccess: setUpdateFlag,
        onDisconnected: () => {},
      },
    }),
  );
};

export const setUpdateFlag = buildInfo => dispatch => {
  const version = parseInt(getBuildNumber());
  const latestVersion = parseInt(buildInfo.latest.version);
  if (version < latestVersion) {
    dispatch(actions.setUpdateFlag(true));
  }
};

export const getDemographics = () => async dispatch => {
  const isDemo =
    Platform.OS === "web" && window.location.hash.includes("demo=true");
  if (isDemo) {
    return;
  }
  const fingerprint = await getFingerprint();
  dispatch(actions.setDemographics(fingerprint));
};

export const getDeviceName = () => async dispatch => {
  const _deviceName = await _getDeviceName();
  const manufacturer = await getManufacturer();
  const deviceName = manufacturer + " " + _deviceName;
  dispatch(actions.setDeviceName(deviceName));
};
